<template>
  <div class="page">
    <div class="head"></div>
    <div class="section">
      <div v-if="!(isApp || miniprogram)" class="back" @click="goBack"></div>
      <!--  -->
      <div class="product-container">
        <div class="product-left">
          <img :src="productDetail.coverMobile" alt="产品图片" class="product-img" />
          <div class="date-box">
            <img src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/ebook/time.png" alt="" />
            <span>{{ startTime }}</span>
          </div>
        </div>
        <div class="product-right">
          <h2 class="product-title">{{ productDetail.name }}</h2>
          <div class="teacher-list" v-if="teacherList.length">
            <div class="box">
              <div class="teacher-item" v-for="(teacher, index) in teacherList" :key="index"
                @click="openTeacher(teacher)">
                <img :src="teacher.teacherHead || require('../../assets/img/loginImg/default.png')" alt=""
                  class="teacher-avatar" />
                <p class="teacher-name">{{ teacher.publicName }}</p>
              </div>
            </div>
          </div>
          <PriceInfo :productDetail="productDetail" />
          <!-- <div class="price-box">
            <div class="price">
              <b v-if="productDetail.sellPrice">¥</b>
              <span>{{ productDetail.sellPrice || '限时免费' }}</span>
            </div>
            <span class="buy-count"
              >{{ productDetail.initialSales + productDetail.realSales }}人已抢购</span
            >
          </div> -->
        </div>
      </div>
      <!-- 学习服务 -->
      <div class="icon-container" v-if="servicesList.length >= 4">
        <div class="icon-item" v-for="(item, index) in servicesList" :key="index" @click="openServer(index, item.type)">
          <img :src="item.icon" alt="功能图标" class="icon-img" />
          <p class="icon-text">{{ item.text }}</p>
        </div>
      </div>

      <div class="icon-container-zzWangji"
        v-if="servicesList.length === 1 || servicesList.length === 2 || servicesList.length === 3">
        <div class="icon-item-zzWangji" v-for="(item, index) in servicesList" :key="index"
          @click="openServer(index, item.type)">
          <img :src="item.icon" alt="功能图标" class="icon-img" />
          <p class="icon-text">{{ item.text }}</p>
        </div>
      </div>
      <!--  -->
      <CouponEntrance :productDetail="productDetail" :buyStatus="buyStatus" />
      <!--  -->
      <div class="book-info-container">
        <div class="tab-bar">
          <div class="tab-item" v-for="(item, index) in tabList" :key="index" :class="{ active: activeTab === index }"
            @click="activeTab = index">
            {{ item.title }}
            <span v-if="activeTab === index" class="tab-underline"></span>
          </div>
        </div>
        <div class="content-area">
          <div v-if="activeTab === 0" class="content-text" v-html="introduction.introduction"></div>
          <div v-if="activeTab === 1">
            <Catalog :styleTemplate="styleTemplate" :buyStatus="buyStatus" :treeData="treeData"
              :productDetail="productDetail" />
          </div>
          <div v-if="activeTab === 2" class="publiser">
            <div v-for="(item, index) in copyRight" :key="index" v-show="item.val">
              <p>{{ item.name }}</p>
              <b>{{ item.val }}</b>
            </div>
          </div>
        </div>
      </div>
      <!--  -->
      <div class="action-bar">
        <div class="action-item" @click="handleConsult">
          <img src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/ebook/chat.png" alt="咨询"
            class="action-icon" />
          <span class="action-text">咨询</span>
        </div>
        <button class="buy-btn" :class="{ active: buyBtnInfo.status === 0 }" @click="handleBuy">
          {{ PageBuyBtnData.btnTxt }}
        </button>
      </div>
    </div>
    <Loading ref="load" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import wx from 'weixin-js-sdk';
import { judgmentPlatform, replaceHyphens, isEbookShowUpdateToast, goApp } from '@/utils/tools';
import Loading from '@/components/loading/loading.vue';
import {
  reqTeacherList,
  reqIsBuyProduct,
  reqSubOrder,
  reqBookTree,
  reqEbookServices,
} from '@/api/courseDetail/index';
import Catalog from './bookComponents/catalog.vue';
import { dateTime } from '@/utils/tools';
import { reqReceiveCoupon } from '@/api/coupon/index';
import PriceInfo from './bookComponents/priceInfo.vue';
import CouponEntrance from './bookComponents/couponEntrance.vue';

export default {
  components: {
    Loading,
    Catalog,
    PriceInfo,
    CouponEntrance,
  },
  props: {
    productDetail: {
      type: Object,
      default: () => { },
    },
  },

  data() {
    return {
      isApp: this.$root.$data.isApp,
      miniprogram: this.$root.$data.miniprogram,
      buyStatus: [],
      teacherList: [],
      // 0 视频 1 试题 2 试卷 3 标记 4音频 5 高频词汇 1007 配套资料
      iconList: {
        english: [
          {
            icon: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/ebook/server1.png',
            text: '视频讲解',
            type: 0,
          },
          {
            icon: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/ebook/server8.png',
            text: '音频讲解',
            type: 4,
          },
          {
            icon: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/ebook/server7.png',
            text: '配套试卷',
            type: 2,
          },
          {
            icon: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/ebook/server5.png',
            text: '高频词汇',
            type: 5,
          },
          {
            icon: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/ebook/server6.png',
            text: '配套资料',
            type: 1007,
          },
        ],
        politics: [
          {
            icon: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/ebook/server1.png',
            text: '视频讲解',
            type: 0,
          },
          {
            icon: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/ebook/server2.png',
            text: '试题练习',
            type: 1,
          },
          {
            icon: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/ebook/server3.png',
            text: '配套试卷',
            type: 2,
          },
          {
            icon: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/ebook/server4.png',
            text: '重点标记',
            type: 3,
          },
        ],
        zzWangji: [
          {
            icon: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/ebook/server3.png',
            text: '配套试卷',
            type: 2,
          },
          {
            icon: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/ebook/server4.png',
            text: '重点标记',
            type: 3,
          },
        ],
        wkPaper: [
        {
            icon: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/ebook/server1.png',
            text: '视频讲解',
            type: 0,
          },
          {
            icon: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/ebook/server3.png',
            text: '配套试卷',
            type: 2,
          },
      ]
      },
      activeTab: 0,
      tabList: [{ title: '图书简介' }, { title: '目录' }, { title: '版权信息' }],
      startTime: '',
      introduction: {},
      buyBtnInfo: {},
      treeData: [],
      copyRight: [],
      PageBuyBtnData: {}, // 购买按钮状态
      styleTemplate: '',
      servicesList: [],
      iconMap: {
        1: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/ebook/server1.png',
        2: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/ebook/server2.png',
        3: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/ebook/server3.png',
        4: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/ebook/server4.png',
        5: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/ebook/server8.png',
        6: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/ebook/server5.png',
        7: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/ebook/server6.png',
      },
    };
  },
  computed: {
    ...mapState(['userInfo', 'allAcvitity']),
    buyBtnData: {
      get() {
        let data = null;
        const { activeType, nowAcvitity } = this.allAcvitity;
        const {
          status,
          isValid,
          validPeriodType,
          isSetStock,
          availableStock,
          isRepeatBuy,
          isChoiceSpec,
          sellPrice,
          productId,
          productSkuRespVOList,
        } = this.productDetail;
        const { productSkuId, price } = productSkuRespVOList?.[0];
        if (status <= 3) {
          data = {
            bgColor: 'notBuy',
            btnTxt: '未上架',
            state: 1,
            status: 0,
          };
        } else if (!isValid && validPeriodType !== 1 && productId) {
          data = { bgColor: 'notBuy', btnTxt: '已过期', state: 3 };
        } else if (this.buyStatus.length && !isRepeatBuy) {
          data = {
            bgColor: 'study',
            btnTxt: '去学习',
            state: 5,
            status: 0,
          };
        } else if (isSetStock === 1 && availableStock <= 0) {
          data = { bgColor: 'sellOut', btnTxt: '已售罄', state: 4 };
        } else if (status === 6) {
          data = { bgColor: 'notBuy', btnTxt: '已下架', state: 2 };
        } else if (
          (isChoiceSpec === 0 && !sellPrice) ||
          (isChoiceSpec === 1 && productSkuId && !price) ||
          (isChoiceSpec === 1 && !productSkuId && !sellPrice)
        ) {
          data = {
            bgColor: 'canBuy',
            btnTxt: '免费领取',
            state: 6,
            status: 1,
          };
        } else if (
          (activeType === 2 && nowAcvitity.state === 1) ||
          (activeType === 3 && nowAcvitity.state === 1 && nowAcvitity.stockNum > 0)
        ) {
          data = {
            bgColor: 'canBuy',
            btnTxt: '马上付款',
            state: 8,
            status: 2,
          };
        } else if (activeType === 1 && nowAcvitity.state === 1) {
          data = {
            bgColor: 'canBuy',
            btnTxt: '立即抢购',
            state: 9,
            status: 2,
          };
        } else if (activeType === 4) {
          data = {
            bgColor: 'coupon',
            btnTxt: '领券购买',
            state: 10,
            status: 2,
          };
        } else {
          data = {
            bgColor: 'canBuy',
            btnTxt: '立即购买',
            state: 7,
            status: 2,
          };
        }
        if (this.$root.miniprogram && !this.$root.miniprogramBuyCourse && data.state > 6) {
          data = {
            bgColor: 'canBuy',
            btnTxt: '了解更多',
            state: 11,
            status: 2,
          };
        }
        return data;
      },
      set(value) {
        this.PageBuyBtnData = value;
      },
    },
  },
  watch: {
    buyBtnData(value) {
      this.PageBuyBtnData = value;
    },
    productDetail: {
      deep: true,
      immediate: true,
      handler(info) {
        console.log('info', info)
        const { productSkuRespVOList } = info || {};
        const { productSkuEbookStyleTemplate } = productSkuRespVOList?.[0] || {};
        this.styleTemplate = productSkuEbookStyleTemplate || '';
      },
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    openServer(index, type) {
      if (!this.userInfo?.id) {
        this.toLogin();
        return;
      }
      const { productSkuRespVOList, productId } = this.productDetail;
      const { productSkuEbookId } = productSkuRespVOList?.[0];
      if (this.isApp) {
        if (judgmentPlatform() === 'HarmonyOS') {
          this.$toast('当前设备不支持，请更换ios/Android最新版学习');
        } else if (isEbookShowUpdateToast(this.styleTemplate)) {
          this.$toast('请更新最新版查看该电子书');
        } else {
          this.$sendToApp(
            'goEBookServicePage',
            {
              bookId: productSkuEbookId,
              userProductId: this.buyStatus?.length ? this.buyStatus?.[0]?.id : 0,
              index,
              productId,
              styleTemplate: this.styleTemplate,
            },
            false,
          );
        }
      } else if (this.miniprogram) {
        wx.miniProgram.navigateTo({
          url: `/eBook/services/index?bookId=${productSkuEbookId}&type=${type}&productId=${productId}&openCourseId=${this.buyStatus?.length ? this.buyStatus?.[0]?.id : 0
            }&styleTemplate=${this.styleTemplate}`,
        });
      } else if (goApp()) {
        this.$toast('请前往启航教育app体验');
      }
    },
    buyBtnStatus() {
      let data = null;
      const {
        status,
        isValid,
        validPeriodType,
        isSetStock,
        availableStock,
        isChoiceSpec,
        sellPrice,
        productId,
        productSkuRespVOList,
      } = this.productDetail;
      const { productSkuId, price } = productSkuRespVOList[0];
      if (status <= 3) {
        data = {
          btnTxt: '未上架',
          status: 0,
        };
      } else if (!isValid && validPeriodType !== 1 && productId) {
        data = { btnTxt: '已过期', status: 0 };
      } else if (isSetStock === 1 && availableStock <= 0) {
        data = { btnTxt: '已售罄', status: 0 };
      } else if (status === 6) {
        data = { btnTxt: '已下架', status: 0 };
      } else if (this.buyStatus?.length) {
        data = { btnTxt: '去学习', status: 3 };
      } else if (
        (isChoiceSpec === 0 && !sellPrice) ||
        (isChoiceSpec === 1 && productSkuId && !price) ||
        (isChoiceSpec === 1 && !productSkuId && !sellPrice)
      ) {
        data = {
          btnTxt: '免费领取',
          status: 1,
          type: 1,
        };
      } else {
        data = {
          btnTxt: '去购买',
          status: 2,
          type: 1,
        };
      }
      if (
        this.miniprogram &&
        !this.$root.miniprogramBuyCourse &&
        data.type == 1 &&
        data.status == 2
      ) {
        data = {
          btnTxt: '了解更多',
          status: 4,
        };
      }
      this.buyBtnInfo = data;
    },
    async getTeacherList() {
      let idsList = [];
      const {
        productAttributeRespVOS,
        validDuration,
        validPeriodType,
        invalidTime,
        productIntroductionRespVOList,
      } = this.productDetail;
      const attributeList = productAttributeRespVOS || [];
      if (productIntroductionRespVOList?.length) {
        this.introduction = productIntroductionRespVOList.find((ele) => ele.terminalType === 2);
      }
      attributeList.forEach((element) => {
        if (element.extendAttributeNameEn === 'teacher') {
          idsList = JSON.parse(element.dataJson);
        }
      });
      const copyRight = [
        {
          name: '出版公司',
          val: '',
        },
        {
          name: '出版时间',
          val: '',
        },
        {
          name: 'ISBN',
          val: '',
        },
        {
          name: '字数',
          val: '',
        },
        // {
        //   name: '集团唯一码',
        //   val: '',
        // },
      ];
      copyRight.forEach((item) => {
        const temp = attributeList.find((data) => data.extendAttributeName === item.name);
        if (temp) {
          Object.assign(item, { val: temp.dataJson });
        }
      });
      this.copyRight = copyRight;
      this.showTime(invalidTime, validPeriodType, validDuration);

      if (!idsList.length) return;
      const res = await reqTeacherList(idsList);
      if (res.code === 0 && res.data) {
        this.teacherList = res.data;
      }
    },
    iosTimeReplace(timeIt) {
      return (timeIt || '').replace(/-/g, '/');
    },
    showTime(startTime, validPeriodType, validDuration) {
      this.startTime =
        validPeriodType == 2 ? `有效期${validDuration}天` : this.formatDate(startTime);
    },
    formatDate(dateStr) {
      const date = new Date(replaceHyphens(dateStr));
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}年${month}月${day}日`;
    },
    // 查询课程是否购买
    async checkBuyCourse() {
      reqIsBuyProduct(this.$route.query.courseId)
        .then((res) => {
          this.buyStatus = res?.data || [];
          this.buyBtnStatus();
        })
        .catch(() => {
          this.buyBtnStatus();
        });
    },
    handleConsult() {
      if (!this.userInfo?.id) {
        this.toLogin();
        return;
      }
      let url =
        'https://pg-chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=67d019b2d81f6f00017fa647';
      if (this.$root.$data.isApp) {
        this.$sendToApp(
          'openNewWebView',
          {
            url,
          },
          false,
        );
        return;
      }
      if (this.$root.miniprogram) {
        const jumpUrl = `/subPackages/webView/webView?url=${encodeURIComponent(url)}`;
        wx.miniProgram.navigateTo({
          url: jumpUrl,
        });
        return;
      }
      window.open(url);
    },
    // 购买按钮
    handleBuy() {
      console.log(this.buyBtnInfo);
      if (this.userInfo.id) {
        const { status } = this.buyBtnInfo;
        if (status === 3) {
          this.toLearn();
        } else if (status === 4) {
          this.handleConsult();
        } else {
          this.toPay();
        }
      } else if (!this.userInfo.id) {
        this.toLogin();
      }
    },
    // 去学习
    toLearn() {
      if (this.isApp) {
        if (judgmentPlatform() === 'HarmonyOS') {
          this.$toast('当前设备不支持，请更换ios/Android最新版学习');
        } else if (isEbookShowUpdateToast(this.styleTemplate)) {
          this.$toast('请更新最新版查看该电子书');
        } else {
          this.$sendToApp('goEBookTutorialPage', { userProductId: this.buyStatus?.[0]?.id }, false);
        }
      } else if (this.miniprogram) {
        wx.miniProgram.navigateTo({
          url: `/myCourse/eBookLearnPage/index?openCourseId=${this.buyStatus?.[0]?.id}`,
        });
      } else if (goApp()) {
        this.$toast('请前往启航教育app体验');
      }
    },
    toPay() {
      if (this.buyBtnInfo.status == 1) {
        this.freeCourseReceive();
      } else {
        this.jumpPayOrder();
      }
    },
    // 跳转到支付页面
    async jumpPayOrder(val) {
      if (this.allAcvitity.activeType === 4) {
        // 领取优惠券
        this.$toast('加载中');
        await this.isReceiveCoupon(this.allAcvitity.couponDetailVO.couponId);
        this.$toast.clear();
      }

      const { productSkuRespVOList } = this.productDetail;
      const query = [
        {
          productId: this.$route.query.courseId,
          skuId: productSkuRespVOList?.[0].productSkuId,
        },
      ];
      if (!this.$root.$data.isApp) {
        this.$router.push({
          path: '/payOrder',
          query: { product: JSON.stringify(query) },
        });
      } else {
        // app内
        this.$sendToApp('buyCourseNew', { product: JSON.stringify(query) }, false);
      }
    },
    async isReceiveCoupon(couponId) {
      const couponData = this.allAcvitity.couponDetailVO.couponChooseRespList.find(
        (item) => item.couponId === couponId,
      );
      if (couponData.hasGetAlready) return;
      const res = await reqReceiveCoupon({
        couponId: couponData.couponId,
        couponVersion: couponData.couponVersion,
        fitEndPoint: this.$root.$data.isApp ? 2 : 4,
        fitPlatform: 1,
        isPrivateCoupon: 0,
        terminalMark: this.$global.terminalMark,
      });
      if (res.code === 0) {
        this.$toast('领取成功');
      } else {
        this.$toast(res.msg);
      }
    },
    // 免费课购买
    async freeCourseReceive() {
      const { productSkuRespVOList } = this.productDetail;
      console.log(productSkuRespVOList, 22);
      const subData = {
        channelMark: 5, // 下单渠道 ：5学员端下单
        products: [
          {
            productId: Number(this.$route.query.courseId),
            productSkuId: productSkuRespVOList?.[0].productSkuId,
            quantity: 1, // 产品数量
            type: 1, // 产品类别 1-主产品 2-增值产品 3-赠送产品
          },
        ],
        terminalMark: this.$global.terminalMark,
        orderReferer: '',
        // eslint-disable-next-line no-undef
        ip: sessionStorage.getItem('cityIp') || '',
        orderUrl: window.location.href,
        extendParam: '',
      };
      this.$refs.load.show = true;
      const res = await reqSubOrder(subData);
      if (res.code === 0) {
        const { orderNo } = res.data;
        setTimeout(() => {
          // 更新开课状态
          this.$router.push({
            path: '/paySuccess',
            query: { orderNo, type: 1 },
          });
          this.$refs.load.show = false;
        }, 2000);
      } else {
        this.$refs.load.show = false;
        this.$toast(res.msg);
      }
    },
    // 去登录isApp
    toLogin() {
      if (this.isApp) {
        this.$sendToApp('login', {}, true);
      } else if (this.miniprogram) {
        let url = window.location.href;
        const [domain, searchParams] = url.split('?');
        if (searchParams) {
          const params = searchParams.split('&');
          const paramsMap = new Map();
          params.forEach((item) => {
            const [key, value] = item.split('=');
            //  console.log('key', key, value);
            if (key) {
              paramsMap.set(key, value);
            }
          });
          const entries = paramsMap.entries();
          let query = '';
          const ExcludequeryArr = ['THIRD_SESSION', 'env'];
          // eslint-disable-next-line no-restricted-syntax
          for (const [key, value] of entries) {
            if (!ExcludequeryArr.includes(key)) query += `${key}=${value}&`;
          }
          url = `${domain}?${query}`;
          const redirctUrl = encodeURIComponent(
            `/subPackages/detailWebView/index?url=${encodeURIComponent(url)}`,
          );
          const path = `/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=${redirctUrl}`;
          wx.miniProgram.redirectTo({
            url: path,
          });
        }
      } else {
        this.$router.push({
          path: '/registrationLogin',
          query: { redirect: '/courseDetail', ...this.$route.query },
        });
      }
    },
    // app 登录回掉
    getLogin(APPSESSION) {
      const ua = navigator.userAgent.toLowerCase();
      const cookieToken = /ohos/.test(ua) ? APPSESSION.token : APPSESSION;
      if ((window?.navigator?.userAgent || '').includes('iqihang')) {
        window.localStorage.setItem('accessToken', cookieToken || '');
        this.getLoginAfter();
      }
    },
    async getLoginAfter() {
      await this.$root.getUserInfo();
    },
    async getTreeData() {
      const { productSkuRespVOList } = this.productDetail;
      const { data } = await reqBookTree(productSkuRespVOList?.[0]?.productSkuEbookId);
      const res = await reqEbookServices(productSkuRespVOList?.[0]?.productSkuEbookId)
      const lsServicesList = res?.data?.map((item) => {
        const { name, type } = item
        return {
          type,
          icon: this.iconMap[type],
          text: name
        }
      })
      console.log('fuwu', res)
      this.servicesList = lsServicesList || []
      this.treeData = data;
    },
    openTeacher(item) {
      if (!this.userInfo?.id) {
        this.toLogin();
        return;
      }
      const url = `${window.location.origin}/ark/teacherDetail?teacherId=${item.id}&productId=${this.$route.query.courseId}`;
      if (this.miniprogram) {
        wx.miniProgram.navigateTo({
          url: `/subPackages/detailWebView/index?url=${encodeURIComponent(url)}`,
        });
      } else if (this.isApp) {
        this.$sendToApp(
          'openNewWebView',
          {
            url,
          },
          false,
        );
      } else {
        this.$router.push({
          path: '/teacherDetail',
          query: { teacherId: item.id, productId: this.$route.query.courseId },
        });
      }
    },
    // header 分享按钮（原生交互）
    shareCourseJS() {
      const query = {
        url: window.location.href,
        title: this.productDetail.name,
        content: '',
        icon: '',
      };
      this.$sendToApp('share', query, false);
    },
    beforePageLeave() {
      this.$sendToApp('closePage');
    },
  },
  created() { },
  mounted() {
    this.checkBuyCourse();
    this.getTeacherList();
    this.getTreeData();
    console.log(this.productDetail, 9999);
    document.title = this.productDetail.name;
    window['iqhApp2jsBridge.triggerSC'] = {};
    setTimeout(() => {
      // 获取登录状态
      window['iqhApp2jsBridge.triggerSC'].getLogin = this.getLogin;
    }, 100);
    // 分享按钮
    window['iqhApp2jsBridge.triggerSC'].shareCourseJS = this.shareCourseJS;
    window.beforePageLeave = this.beforePageLeave;
  },
};
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none;
}

.page {
  width: 100%;
  min-height: 100vh;
  padding-bottom: 180px;
  background: #f7f8fc;

  .head {
    position: absolute;
    top: 0;
    z-index: 1;
    width: 100%;
    height: 446px;
    background: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/ebook/book-bg.png') no-repeat;
    background-size: 100%;
  }

  .section {
    position: relative;
    z-index: 2;
    padding-top: 40px;

    .back {
      width: 43px;
      height: 43px;
      margin-left: 31px;
      background: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/ebook/back.png') no-repeat;
      background-size: 100%;
    }

    .product-container {
      display: flex;
      padding: 42px 36px 36px 36px;
    }

    .product-left {
      position: relative;
      flex-shrink: 0;
      width: 197px;
      height: 263px;
      background: #fff;
      border-radius: 18px;

      .product-img {
        width: 100%;
        height: 100%;
        border-radius: 10px;
      }

      .date-box {
        position: absolute;
        right: 0;
        bottom: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 47px;
        background: rgba(0, 0, 0, 0.5);
        border-radius: 0 0 18px 18px;

        img {
          width: 22px;
          height: 22px;
        }

        span {
          padding-left: 7px;
          color: #fff;
          font-weight: 500;
          font-size: 18px;
        }
      }
    }

    .product-right {
      position: relative;
      padding-left: 40px;

      .product-title {
        display: -webkit-box;
        padding-bottom: 22px;
        overflow: hidden;
        color: #333;
        font-weight: 500;
        font-size: 29px;
        line-height: 38px;
        text-overflow: ellipsis;
        word-break: break-all;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      .teacher-list {
        display: flex;
        width: 400px;
        margin-bottom: 16px;
        overflow: hidden;

        .box {
          display: flex;
          width: 100%;
          overflow-x: scroll;
        }
      }

      .teacher-item {
        margin-right: 14px;
        text-align: center;
      }

      .teacher-avatar {
        width: 45px;
        height: 45px;
        margin: 0 auto;
        border-radius: 50%;
      }

      .teacher-name {
        width: 100px;
        margin-top: 11px;
        overflow: hidden;
        color: #999;
        font-weight: 400;
        font-size: 22px;
        white-space: nowrap;
        text-align: center;
        text-overflow: ellipsis;
      }

      .flame-icon {
        width: 20px;
        height: 20px;
        background: linear-gradient(45deg, #f00, #ff8c00);
        clip-path: polygon(50% 0%,
            61% 35%,
            98% 35%,
            68% 57%,
            79% 91%,
            50% 70%,
            21% 91%,
            32% 57%,
            2% 35%,
            39% 35%);
      }

      .price {
        color: #f40;
        font-weight: bold;
        font-size: 18px;
      }
    }

    .icon-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 678px;
      height: 158px;
      margin: 0 auto;
      padding: 0 36px;
      background: #fff;
      border-radius: 14px;

      .icon-item {
        display: flex;
        flex-direction: column;
        align-items: center;

        .icon-img {
          width: 72px;
          height: 72px;
        }

        .icon-text {
          padding-top: 11px;
          color: #333;
          font-weight: 400;
          font-size: 22px;
        }
      }
    }

    .icon-container-zzWangji {
      display: flex;
      gap: 22px;
      align-items: center;
      justify-content: space-between;
      width: 678px;
      height: 158px;
      margin: 0 auto;
      border-radius: 14px;

      .icon-item-zzWangji {
        display: flex;
        flex: 1;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        max-width: 330px;
        height: 158px;
        background: #FFF;
        border-radius: 14px;

        .icon-img {
          width: 72px;
          height: 72px;
        }

        .icon-text {
          padding-top: 11px;
          color: #333;
          font-weight: 400;
          font-size: 22px;
        }
      }
    }

    //
    .book-info-container {
      width: 100%;
      min-height: 53vh;
      margin-top: 22px;
      background: #fff;
      border-radius: 36px 36px 0 0;

      .tab-bar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 105px;
        padding: 0 72px;
        background: #fff;
        border-radius: 36px 36px 0 0;

        .tab-item {
          position: relative;
          color: #333;
          font-weight: 600;
          font-size: 29px;

          &.active {
            color: #333;
          }

          .tab-underline {
            position: absolute;
            right: 0;
            bottom: -10px;
            left: 0;
            width: 29px;
            height: 2px;
            height: 7px;
            margin: 0 auto;
            background: #ff7f41;
            border-radius: 6px;
          }
        }
      }

      .content-area {
        padding: 0 36px;

        .content-text {
          color: #333;
          font-size: 25px;
          line-height: 43px;
          word-break: break-all;

          img {
            max-width: 100%;
          }
        }

        .publiser {
          padding-top: 22px;

          div {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            padding-bottom: 51px;

            p {
              flex-shrink: 0;
              width: 200px;
              padding-right: 36px;
              color: #999;
              font-weight: 400;
              font-size: 25px;
            }

            b {
              color: #333;
              font-weight: 400;
              font-size: 25px;
              line-height: 36px;
            }
          }
        }
      }
    }

    //
    .action-bar {
      position: fixed;
      right: 0;
      bottom: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 181px;
      padding: 0 36px 0 54px;
      background: #fefffe;
      box-shadow: 0 -4 7px 0 rgba(0, 0, 0, 0.05);

      .action-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 43px;

        .action-icon {
          width: 54px;
          height: 54px;
        }

        .action-text {
          color: #333;
          font-weight: 400;
          font-size: 18px;
        }
      }

      .buy-btn {
        width: 562px;
        height: 82px;
        color: #fff;
        font-weight: 500;
        font-size: 29px;
        line-height: 82px;
        background: linear-gradient(90deg, #ff6c02 0%, #ff7f41 100%);
        border-radius: 41px;
        opacity: 1;
      }

      .active.buy-btn {
        opacity: 0.5;
        pointer-events: none;
      }
    }
  }
}
</style>
